module.exports = __webpack_public_path__ + "media/images/icon-foryourorg-0c997bde8417e6eeaead8cba59fb4e2a.svg";